import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css']
})
export class ButtonComponent {
  @Input() text: string = '';
  @Input() color: string = '#dc3545'; // Cor padrão vermelha
  @Input() height: string = '40px';
  @Input() width: string = 'auto';
  @Input() disabled: boolean = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() className: string = '';

  @Output() buttonClick = new EventEmitter<void>();

  onClick(): void {
    if (!this.disabled) {
      this.buttonClick.emit();
    }
  }

  get buttonStyles(): { [key: string]: string } {
    return {
      backgroundColor: this.color,
      height: this.height,
      width: this.width,
      cursor: this.disabled ? 'not-allowed' : 'pointer',
      opacity: this.disabled ? '0.6' : '1'
    };
  }
} 